module.exports = __webpack_public_path__ + "img/bgd4.425f8e4f.png";